<template>
  <div>
    <div class="company-select">
      <div class="tabs">
        <ul>
          <li :class="{'is-active': company.initials === null}">
            <a @click="setCompany(null)">All Companies</a>
          </li>
          <li :class="{'is-active': company.initials === 'CF'}">
            <a @click="setCompany('CF')">
              Crockett Farms
              <span v-if="cfOrders.length > 0">
                                &nbsp;
                                <span class="tag is-rounded is-danger">{{ cfOrders.length }}</span>
                            </span>
            </a>
          </li>
          <li :class="{'is-active': company.initials === 'BELLS'}">
            <a @click="setCompany('BELLS')">
              Bells Farm To Market
              <span v-if="bellsOrders.length > 0">
                                &nbsp;
                                <span class="tag is-rounded is-danger">{{ bellsOrders.length }}</span>
                            </span>
            </a></li>
        </ul>
      </div>
    </div>
    <nav class="navbar is-dark" role="navigation" aria-label="dropdown navigation">
      <div class="navbar-brand">
        <router-link :to="{ name: 'home' }" class="navbar-item" exact>
                        <span class="icon">
                          <i class="fa fa-home"></i>
                        </span>
          &nbsp;
          Dashboard ({{ admin.first_name }})
        </router-link>
        <span :class="{'navbar-burger burger': true, 'is-active': showNavMenu}"
              @click="showNavMenu = !showNavMenu">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
      </div>


      <!-- This "nav-menu" is hidden on mobile -->
      <!-- Add the modifier "is-active" to display it on mobile -->
      <div :class="{'navbar-menu': true, 'is-active': showNavMenu}">
        <div class="navbar-end">
          <!--
            <router-link class="navbar-item" :to="{ name: 'new-order' }"><i class="fa fa-plus"></i> &nbsp; New Order</router-link>
            -->
          <router-link class="navbar-item" :to="{ name: 'orders' }">Orders</router-link>
          <router-link class="navbar-item" :to="{ name: 'requests' }">Mailing</router-link>
          <router-link class="navbar-item" :to="{ name: 'users' }">Users</router-link>
          <router-link class="navbar-item" :to="{ name: 'products' }" v-if="isSuperUser">
            Product Management
          </router-link>
          <router-link class="navbar-item" :to="{ name: 'pages' }" v-if="isSuperUser">
            Pages
          </router-link>
          <router-link class="navbar-item" :to="{ name: 'images' }" v-if="isSuperUser">
            Images
          </router-link>
          <router-link class="navbar-item" :to="{ name: 'admins' }" v-if="isSuperUser">
            Admins
          </router-link>
          <router-link class="navbar-item" :to="{ name: 'reports' }" v-if="isSuperUser">
            Reports
          </router-link>
          <span class="navbar-item">
                            <a class="button is-primary" @click="logout()">
                                <span>Logout</span>
                                <span class="icon">
                                  <i class="fa fa-sign-in"></i>
                                </span>
                            </a>
                        </span>
        </div>
      </div>
    </nav>
  </div>
</template>

<style lang="scss">
  .company-select {
    font-size: 0;
    background-color: #222;

    ul {
      border-bottom-color: #222;
    }

    li {
      font-size: 0.75rem;
      padding: 0;

      a {
        color: #666;
        border-bottom-color: #222;

        .tag {
          height: 1.5em;
        }
      }

      &.is-active {
        background-color: #555;

        a {
          border-bottom-color: #555;
          color: #FFF;
        }
      }
    }
  }
</style>

<script>
import {
  LOGOUT,
}                   from "../store/mutation-types"
import {mapGetters} from "vuex";

export default {
  name: 'app-header',
  data() {
    return {
      showNavMenu: false,
    }
  },
  computed: Object.assign({},
    mapGetters(['auth', 'admin', 'isSuperUser', 'apiBusy', 'company', 'newOrdersByCompany']),
    {
      cfOrders() {
        return this.newOrdersByCompany.filter(order => order.company !== 'BELLS')
      },
      bellsOrders() {
        return this.newOrdersByCompany.filter(order => order.company === 'BELLS')
      },
    }
  ),
  watch: {
    '$route.name': {
      handler() {
        this.showNavMenu = false
      }
    }
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT)
    },
    setCompany(company) {
      this.$store.dispatch('SET_COMPANY', company)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Header.vue?662cf239